
























import Vue, { PropType } from "vue";
import { IRemindPrizeItem, IMyPrizeItem } from "@/types";
import { cutImage } from "@/utils/img";
import { formatDate } from "@/utils/format";

export default Vue.extend({
  name: "PrizesComp",
  props: {
    prizeList: {
      type: Array as PropType<(IRemindPrizeItem | IMyPrizeItem)[]>,
      default: []
    },
    btnClassGetter: {
      type: Function
    },
    btnClickHandler: {
      type: Function
    },
    btnTextGetter: {
      type: Function
    }
  },
  methods: {
    formatTime(time): string {
      // 北京时间
      const date = new Date(time * 1000);
      const utc = new Date(time * 1000 + (date.getTimezoneOffset() * 60000));
      const bj = utc.getTime() + 480 * 60000;
      return formatDate("YYYY/MM/DD hh:mm", bj);
    },
    cutImage(url: string, width: number): string {
      return cutImage(url, width);
    }
  }
});
